import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4120f82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "form fv-plugins-bootstrap5 fv-plugins-framework",
  style: {"max-height":"90vh","overflow":"scroll"}
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold" }, "Sophisticated Investor Test Record", -1))
const _hoisted_6 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "p-7" }
const _hoisted_9 = {
  class: "fv-row mb-10 ms-3",
  style: {"font-size":"16px"}
}
const _hoisted_10 = { class: "questionTitle mb-4" }
const _hoisted_11 = {
  key: 0,
  class: "ms-7 mb-7"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import { ref } from "vue";
import { showModal, hideModal } from "@/core/helpers/dom";
import clientAns from "@/core/data/wholesaleAns";
import questionDB from "@/core/data/wholesaleTest";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewQuizRecordModal',
  setup(__props, { expose: __expose }) {

const quizRecord = ref<any>({});
const questions = ref<any>({});
const isLoading = ref(false);

const createPaymentMethodRef = ref<null | HTMLElement>(null);

const loadQuestions = () => {
  isLoading.value = true;
  questions.value = {};

  quizRecord.value.forEach((item) => {
    questions.value[item.id] = questionDB["en-us"][item.id];
    questions.value[item.id]["ans"] = item.answer;
  });
  isLoading.value = false;
};

const show = async (_QnA) => {
  quizRecord.value = _QnA;
  loadQuestions();
  showModal(createPaymentMethodRef.value);
};

const hide = () => {
  hideModal(createPaymentMethodRef.value);
};

__expose({
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "kt_modal_create_deposit",
    tabindex: "-1",
    "aria-hidden": "true",
    ref_key: "createPaymentMethodRef",
    ref: createPaymentMethodRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("strong", {
                      class: _normalizeClass(["me-3", 
                      item.ans != _unref(clientAns)[item.id].answer
                        ? 'wrong'
                        : 'correct'
                    ]),
                      style: {"text-transform":"uppercase"}
                    }, _toDisplayString(item.ans), 3),
                    _createElementVNode("span", null, _toDisplayString(item.question), 1)
                  ]),
                  (item.ans != _unref(clientAns)[item.id].answer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, val, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "d-flex mt-3",
                            key: index
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(
                        ['a', 'b', 'c', 'd'][index] == item.ans ? 'wrong' : ''
                      )
                            }, _toDisplayString(option), 3)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_12
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 512))
}
}

})